import {Inject, Pipe, PipeTransform} from '@angular/core';
import {FonctionUtiles} from "../../utils/fonctionsUtiles";

@Pipe({
  name: 'commission'
})


export class CommissionPipe implements PipeTransform {

  constructor(private fonctionUtils: FonctionUtiles) {

  }

  transform(tickets:any,event): any {
    return this.fonctionUtils.calculOrganizerFrais(tickets,event);
  }

}
